<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
      <template #action>
        <div v-if="open" class="content-container-app">

          <!-- 承認フロー -->
          <div class="">

            <!-- 優先順位 -->
            <div class="my-8">
              <span class="text-sm text-gray-700">優先順位<br> <span class="text-xs">数値が大きいほど上にきます</span></span>
              <input
                type="number"
                v-model="approval.priority"
                class="border-gray text-center focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
              >
            </div>

            <!-- 承認 ルート名 -->
            <div class="text-sm text-gray-700 mb-1">ルート名</div>
            <input
              type="text" 
              name="routeName"
              v-model="approval.routeName"
              class="focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded w-full font-bold"
            />

            <!-- 承認 -->
            <div class="con my-8">
              <div class="mr-3 w-full">
                <table class="table-auto table">
                  <thead>
                    <tr>
                      <th class="py-2 text-center text-xs font-medium text-gray-700 tracking-wider border-gray w-full app1-color">
                        承認者1
                      </th>
                      <th>
                        <!-- プラスボタン -->
                        <PlusCircleIcon v-if="!approval.approver1.length" class="text-indigo-500 hover:text-indigo-700 active:text-indigo-600 cursor-pointer col-actions" @click="addRowApproval(1)" />
                      </th>
                    </tr>
                  </thead>

                  <tr v-for="(flow1, index) in approval.approver1" :key="index">
                    <td class="text-center px-0.5 py-0.5 text-xs font-medium text-gray-700 tracking-wider border-gray td-height w-full">
                      <form>
                        <select
                          name="approvalFlow1"
                          v-model="flow1.userId"
                          @change="selectedApprover(index, flow1.userId, 1)"
                          class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block border-gray text-base rounded pl-2 w-full border-transparent"
                        >
                          <option
                            v-for="value in approverList1" :key='value.id'
                            :value="value.userId"
                            class="bg-white text-l">
                            {{ value.userName }}
                          </option>
                        </select>
                      </form>
                    </td>
                    <td class="px-0.5 py-0.5 whitespace-nowrap text-sm font-medium">
                      <TrashIcon class="text-gray-500 cursor-pointer w-5 h-5" @click="deleteApprovalRow(index, 1)" />
                    </td>
                  </tr>
                  <span class="text-sm text-gray-500 p-3" v-if="!approval.approver1.length">1番目の承認者は設定されていません</span>
                </table>
              </div>
              
              <!-- 承認2 -->
              <div class="ml-3 w-full">
                <table class="table-auto table">
                  <thead>
                    <tr>
                      <th class="py-2 text-center text-xs font-medium text-gray-700 tracking-wider border-gray w-full app1-color">
                        承認者2
                      </th>
                      <th>
                        <!-- プラスボタン -->
                        <PlusCircleIcon v-if="!approval.approver2.length" class="text-indigo-500 hover:text-indigo-700 active:text-indigo-600 cursor-pointer col-actions" @click="addRowApproval(2)" />
                      </th>
                    </tr>
                  </thead>

                  <tr v-for="(flow2, index) in approval.approver2" :key="index">
                    <td class="text-center px-0.5 py-0.5 text-xs font-medium text-gray-700 tracking-wider border-gray td-height">
                      <select
                        name="approver2"
                        v-model="flow2.userId"
                        @change="selectedApprover(index, flow2.userId, 2)"
                        class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block border-gray w-full text-base rounded pl-2 border-transparent"
                      >
                        <option
                          v-for="value in approverList2" :key='value.id'
                          :value="value.userId"
                          class="bg-white text-l">
                          {{ value.userName }}
                        </option>
                      </select>
                    </td>
                    <td class="px-0.5 py-0.5 whitespace-nowrap text-sm font-medium">
                      <TrashIcon class="text-gray-500 cursor-pointer w-5 h-5" @click="deleteApprovalRow(index, 2)" />
                    </td>
                  </tr>
                  <span class="text-sm text-gray-500 p-3" v-if="!approval.approver2.length">2番目の承認者は設定されていません</span>
                </table>
              </div>
            </div>

            <!-- 部署 -->
            <div class="w-fit">
              <div class="flex text-sm mb-1 text-gray-700">
                対象部署
                <!-- プラスボタン -->
                <PlusCircleIcon class="ml-auto text-indigo-500 hover:text-indigo-700 active:text-indigo-600 cursor-pointer col-actions" @click="addDep()" />
              </div>
              <div v-for="(row, i) in approval.departments" :key="'dep'+i" class="flex mb-1">
                <select
                  v-model="approval.departments[i]"
                  class="border-gray-300 rounded "
                >
                  <option
                    v-for="value in depList" :key="value.departmentId + i"
                    :value="value.departmentId"
                    class="bg-white text-l">
                    {{ value.name }}
                  </option>
                </select>

                <TrashIcon class="text-gray-500 self-center cursor-pointer w-5 h-5 mx-2" @click="deleteDep(i)" />
              </div>
            </div>
          </div>
          <div class="text-transparent">{{reload}}</div>
          <div class="m-1">
            <PrimaryButton text="登録" size="normal my-5 w-full" @click="register()"/>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import { TrashIcon, PlusCircleIcon } from '@vue-hero-icons/solid'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as estimateManager from '@managers/estimateManager'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as logManager from '@managers/logManager'

const ROW = [{
            userId: '',
            userName: '',
            chatworkAccountId: ''
          }]

export default {
  components: {
    Modal,
    TrashIcon,
    PlusCircleIcon,
    PrimaryButton,
  },

  props: {
    target: {
      type: Object
    },
    open: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      reload: 0,
      // 登録する内容
      approval: {
        // 優先度
        priority: '0',
        // ルート名
        routeName: '',
        // 承認者1
        approver1: utils.clone(ROW),
        // 承認者2
        approver2: utils.clone(ROW),
        // 部署
        departments: ['']
      },
      // 承認権限者リスト
      allApprovers: [],
      // 部署リスト
      depList: []
    }
  },

  async created() {
    let all = await backend.getData('user/getAllByEstimateApprove')
    this.allApprovers = all.data.data
  },

  computed: {
    /**
     * 承認者リスト取得
     */
    approverList1() {
      let result = []
      for (let i = 0; i < this.allApprovers.length; i++) {
        let ap = this.allApprovers[i]
        if (ap.estimateApproveAuth) {
          result.push({userId: ap.mstUserId, userName: ap.userName, chatworkAccountId: ap.chatworkAccountId})
        }
      }
      if (!result.length) {
        result.push({userId:'', userName: '承認権限者がいません', chatworkAccountId: ''})
      }
      return result
    },

    approverList2() {
      let result = []
      for (let i = 0; i < this.allApprovers.length; i++) {
        let ap = this.allApprovers[i]
        if (ap.estimateApproveAuth) {
          result.push({userId: ap.mstUserId, userName: ap.userName, chatworkAccountId: ap.chatworkAccountId})
        }
      }
      if (!result.length) {
        result.push({userId:'', userName: '承認権限者がいません', chatworkAccountId: ''})
      }
      return result
    },
  },

  watch: {
    open() {
      if (this.open) {
        this.getTarget()
      }
    }
  },

  methods: {
    /**
     * 表示するデータ取得
     */
    getTarget() {
      this.depList = [{ name: '全部署', departmentId: '' }].concat(utils.clone(this.$store.getters.departmentList))

      // 編集の場合
      if (this.target && Object.keys(this.target).length) {
        this.approval = this.target
        // ルームIDは別のを使用するので、削除
        for (let aI = 0; aI < this.approval.approver1.length; aI++) {
          const ap1 = this.approval.approver1[aI];
          delete ap1.chatworkRoomId
        }
        for (let pI = 0; pI < this.approval.approver2.length; pI++) {
          const ap2 = this.approval.approver2[pI];
          delete ap2.chatworkRoomId
        }

        if (!this.approval.departments || !this.approval.departments.length) {
          this.approval.departments = ['']
        }
      }
    },

    /**
     * 承認者選択イベント
     */
    async selectedApprover(index, userId, sequentialOrder) {
      if (userId == '') {
        return
      }

      let appData = {
        userId: '',
        userName: '',
        chatworkAccountId: ''
      }

      switch (sequentialOrder) {
        case 1: {
          let result = this.approverList1.filter((a) => {
            return a.userId == userId
          })

          for (let i = 0; i < this.approval.approver1.length; i++) {
            if (i != index) {
              if (this.approval.approver1[i].userId == userId) {
                await dialogs.showErrorDialog('選択不可', '同じ承認者が既に選択されています。')
                this.approval.approver1.splice(index, 1 , appData)
                return
              }
            }
          }

          this.approval.approver1[index]['userName'] = result[0].userName
          this.approval.approver1[index]['chatworkAccountId'] = result[0].chatworkAccountId
          break;
        }
        case 2: {
          let result = this.approverList2.filter((a) => {
            return a.userId == userId
          })

          for (let i = 0; i < this.approval.approver2.length; i++) {
            if (i != index) {
              if (this.approval.approver2[i].userId == userId) {
                await dialogs.showErrorDialog('選択不可', '同じ承認者が既に選択されています。')
                this.approval.approver2.splice(index, 1 , appData)
                return
              }
            }
          }
          
          this.approval.approver2[index]['userName'] = result[0].userName
          this.approval.approver2[index]['chatworkAccountId'] = result[0].chatworkAccountId
          // this.approval.approver2[index]['chatworkApiToken'] = result[0].chatworkApiToken
          break;
        }
      
        default:
          break;
      }
    },

    /**
     * 削除ボタンイベント
     * @param index 行番号
     * @param sequentialOrder 承認順番
     */
    deleteApprovalRow(index, sequentialOrder) {
      switch (sequentialOrder) {
        case 1:
          this.approval.approver1.splice(index, 1)
          break;
        case 2:
          this.approval.approver2.splice(index, 1)
          break;
      
        default:
          break;
      }
    },

    /**
     * 追加ボタンイベント
     * @param sequentialOrder 承認順番
     */
    addRowApproval(sequentialOrder) {
      let appData = {
        userId: '',
        userName: '',
        chatworkAccountId: '',
        // chatworkApiToken: ''
      }

      switch (sequentialOrder) {
        case 1:
          this.approval.approver1.push(appData)
          break;
        case 2:
          this.approval.approver2.push(appData)
          break;
      
        default:
          break;
      }
    },

    /**
     * 部署追加
     */
    addDep() {
      this.approval.departments.push('')
      this.reload++
    },

    /**
     * 部署削除
     */
    deleteDep(i) {
      this.approval.departments.splice(i, 1)
      if (!this.approval.departments || !this.approval.departments.length) {
        this.addDep()
      }
      this.reload++
    },

    /**
     * 初期化
     */
    closed() {
      // 登録する内容
      this.approval = {
        // 優先度
        priority: '0',
        // ルート名
        routeName: '',
        // 承認者1
        approver1: utils.clone(ROW),
        // 承認者2
        approver2: utils.clone(ROW),
        // 部署
        departments: ['']
      }
    },

    /**
     * 登録処理
     */
    async register() {
      // ルート名が入力されているかチェック
      if (this.approval.routeName == '') {
        await dialogs.showErrorDialog('登録不可', 'ルート名が入力されていません。')
        return
      }
      // 同じルート名がないかチェック
      let list = await estimateManager.getApprover(this)

      for (let i = 0; i < list.length; i++) {
        if (list[i]._id != this.approval._id && list[i].routeName == this.approval.routeName) {
          await dialogs.showErrorDialog('登録不可', '同じルート名が存在します。\r\n違うルート名に変更してください。')
          return
        }
      }
      // 承認1と承認2に同じ人物が登録されていないかチェック
      if (this.approval.approver2.length && this.approval.approver2.length > 0) {
        for (let i = 0; i < this.approval.approver1.length; i++) {
          for (let j = 0; j < this.approval.approver2.length; j++) {
            if (this.approval.approver1[i].userId == this.approval.approver2[j].userId) {
              await dialogs.showErrorDialog('登録不可', '承認1と2に同じ人が登録されています。')
              return
            }
          }
        }
      }

      // 空行は削除
      let number1 = []
      let number2 = []
      for (let i = 0; i < this.approval.approver1.length; i++) {
        if (this.approval.approver1[i].userId) {
          number1.push(this.approval.approver1[i])
        }
      }
      for (let i = 0; i < this.approval.approver2.length; i++) {
        if (this.approval.approver2[i].userId) {
          number2.push(this.approval.approver2[i])
        }
      }
      
      this.approval.approver1 = number1
      this.approval.approver2 = number2

      // 承認1が1人以上設定されているか確認
      if (this.approval.approver1.length < 1) {
        await dialogs.showErrorDialog('登録不可', '承認1が設定されていません。')
        return
      }

      // 優先順位
      this.approval.priority = Number(this.approval.priority)
      if (!this.approval.priority) {
        await dialogs.showErrorDialog('優先順位', '優先順位を入力してください。')
        return
      }

      // 部署
      if (this.approval.departments && this.approval.departments.length) {
        // 全部署
        if (this.approval.departments.includes('')) {
          this.approval.departments = ['']
        } else {
          // 重複削除
          this.approval.departments = [...new Set(this.approval.departments)]
        }
      }
      
      // 不要なものを削除
      delete this.approval.approver1List
      delete this.approval.approver2List

      // 承認ルートを承認マスタに登録
      if (this.approval._id) {
        let registApp = await estimateManager.updateTasks(this, this.approval._id, this.approval)
        if (!registApp) {
          await dialogs.showErrorDialog('エラー', '更新できませんでした。')
          return
        } else {
          await dialogs.showSuccessDialog('承認ルートの更新', '更新しました。')
          logManager.recordingByRegist(this, false, '承認ルート', '承認ルート（' + this.approval.routeName + '）')
          this.$emit('modalClose')
        }
      } else {
        let registApp = await estimateManager.registerTasks(this, 'estimate_approver_master', this.approval, {})
        if (!registApp) {
          await dialogs.showErrorDialog('エラー', '保存できませんでした。')
          return
        } else {
          await dialogs.showSuccessDialog('承認ルートの保存', '保存しました。')
          logManager.recordingByRegist(this, true, '承認ルート', '承認ルート（' + this.approval.routeName + '）')
          this.$emit('modalClose')
        }
      }
      this.closed()
    }
  }
}
</script>
<style scoped>
.content-container-app {
  width: 900px;
  overflow: auto;
  padding: 10px;
}

.border-gray {
  border: solid #d3cfcf 1px;
}

.td-height {
  height: 40px;
}

.table {
  width: auto;
  margin: auto;
}

.table-width {
  width: 350px;
}

.app1-color {
  background-color: rgb(253 237 237 / 53%);
}

.con {
  display: flex;
  justify-content: space-around;
}

@media screen and (max-width: 910px) {
  .content-container-app {
    width: 900px !important;
    overflow: auto;
  }
}
</style>